import { render, staticRenderFns } from "./MatterCustomsRegistrationForm.vue?vue&type=template&id=f723f052&"
import script from "./MatterCustomsRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MatterCustomsRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterCustomsRegistrationForm.vue?vue&type=style&index=0&id=f723f052&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports